import { Box, Grid, useTheme } from "@mui/material";
import React, { useContext } from "react";
import { UserTypeContext } from "../../context/userStatus";
import { TrackingContext } from "../../context/userTracking";
import SideBar from "../../components/SideBar";
import { setSidebarExpand } from "../../store/actions/trackerAction";
import TrackHeader from "../tracker/TrackHeader";
import insightsProgressStyles from "../insightsV2/insightsClasses";
import RestrictedWidget from "../../components/RestrictedWidget";

const PageWithRestrictedWidget = ({ Component }) => {
    const classes = insightsProgressStyles();
    const { state: IUserTypeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    const { state: ITrackerState, dispatch: trackingDispatch } =
        useContext(TrackingContext);
    const { isExpandable, isArchiveMode, } = ITrackerState;
    const isDarkMode = useTheme().palette.mode === "dark" || IUserTypeState.isDarkMode
    return IUserTypeState.restrictUser ? (
        <Grid
            container
            columns={16}
            // height={"100vh"}
            sx={{ /* maxHeight: '100vh', */ overflow: "hidden" }}
            className="tracking_container"
        // style={{
        //   height: '100vh !important'
        // }}
        >
            <Grid
                item
                // xs={/* IUserTypeState?.isExpand ||  */ isExpandable ? 0.72 : 2.04}
                width={isExpandable ? "90px" : "220px"}
                sx={{ borderRight: isDarkMode ? "1px solid var(--dark-border-color)" : "1px solid #DCE6E0", height: "100vh" }}
                position={"relative"}
            >
                <SideBar
                    isExpandMode={isExpandable}
                    setIsExpandMode={(val) => {
                        trackingDispatch(setSidebarExpand(val));
                    }}
                />
            </Grid>
            <Grid
                item
                // xs={isExpandable ? 15.27 : 13.96}
                sx={{
                    flexDirection: "column",
                    background: "transparent !important",
                    height: "100vh",
                    padding: "0px 0px",
                    width: isExpandable ? "calc(100vw - 90px)" : "calc(100vw - 220px)"
                }}
                className={classes.trackBodyGrid}
            >
                <Box sx={{
                    padding: "0px 0px 16px 0px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "32px"
                }}>
                    <Box sx={{
                        padding: "0px 0px 16px",
                        borderBottom: isDarkMode ? "1px solid var(--dark-border-color)" : "1px solid #EEEEEE"
                    }}>
                        <TrackHeader setIsArchiveMode={() => {

                        }} />
                    </Box>
                    <Box sx={{
                        padding: "0px 16px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "32px"
                    }}>
                        <RestrictedWidget />
                    </Box>
                </Box>
            </Grid>
        </Grid>
    ) : <Component />
}

export default PageWithRestrictedWidget